<script setup></script>

<template>
  <svg width="16" height="16" class="min-h-[16px] min-w-[16px]" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
    <rect x="2" y="2" width="12" height="12" rx="6" />
    <path d="M8 11L8 8" stroke-linecap="round" stroke-linejoin="round" />
    <path d="M8 6L8 5" stroke-linecap="round" stroke-linejoin="round" />
  </svg>
</template>

<style scoped lang="scss"></style>
